import { createSlice } from '@reduxjs/toolkit';
import * as oPath from '../../../Lib/Object/Path/Mutable';
import {
  AddTempSeparationAction,
  IPsdSieveAnalysisState,
  RemoveSeparationAction,
  RemoveTempSeparationAction,
  SetTempSeparationsAction,
  SetTempSeparationValueAction,
} from './types';

const name = 'worksheetEditor.psdSieveAnalysis';

const initialState: IPsdSieveAnalysisState = {
  separationManagement: {
    separations: [],
    status: {
      loading: false,
      loadingFailed: false,
      synchronising: false,
      submissionFailed: false,
      submitting: false,
      removing: false,
    },
  },
  refreshSieves: {
    status: {
      submissionFailed: false,
      submitting: false,
    },
  },
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    initTempSeparations: (state) => {
      state.separationManagement.status.loading = true;
      state.separationManagement.status.loadingFailed = false;
    },
    initTempSeparationsResolve: (state) => {
      state.separationManagement.status.loading = false;
      state.separationManagement.status.loadingFailed = false;
    },
    initTempSeparationsReject: (state) => {
      state.separationManagement.status.loading = false;
      state.separationManagement.status.loadingFailed = true;
    },
    applyTempSeparationsToWorksheet: (state) => {
      state.separationManagement.status.submitting = true;
      state.separationManagement.status.submissionFailed = false;
    },
    applyTempSeparationsToWorksheetResolve: (state) => {
      state.separationManagement.status.submitting = false;
    },
    applyTempSeparationsToWorksheetReject: (state) => {
      state.separationManagement.status.submitting = false;
      state.separationManagement.status.submissionFailed = true;
    },
    setTempSeparations: (state, action: SetTempSeparationsAction) => {
      state.separationManagement.separations = action.payload.separations;
    },
    removeTempSeparation: (state, action: RemoveTempSeparationAction) => {
      if (!state.separationManagement.separations) state.separationManagement.separations = [];
      else state.separationManagement.separations.splice(action.payload.index, 1);
    },
    addTempSeparation: (state, action: AddTempSeparationAction) => {
      const { payload: { index } = {} } = action;
      state.separationManagement.separations = [
        ...state.separationManagement.separations.slice(0, index),
        {},
        ...state.separationManagement.separations.slice(index),
      ];
    },
    setTempSeparationValue: (state, action: SetTempSeparationValueAction) => {
      const { payload: { index, name, value } = {} } = action;
      oPath.set(state.separationManagement.separations, `${index}.${name}`, value);
    },
    removeSeparation: (state, action: RemoveSeparationAction) => {
      state.separationManagement.status.removing = true;
    },
    removeSeparationResolve: (state) => {
      state.separationManagement.status.removing = false;
    },
    removeSeparationReject: (state) => {
      state.separationManagement.status.removing = false;
    },

    refreshSieves: (state) => {
      state.refreshSieves.status.submitting = true;
      state.refreshSieves.status.submissionFailed = false;
    },
    refreshSievesResolve: (state) => {
      state.refreshSieves.status.submitting = false;
    },
    refreshSievesReject: (state) => {
      state.refreshSieves.status.submitting = false;
      state.refreshSieves.status.submissionFailed = true;
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
